import { IPlanAdd } from '@shared/components';
import { create } from 'zustand';

export type ICheckoutStateSelectedPlans = IPlanAdd;

interface ICheckoutState {
  selectedPlans: ICheckoutStateSelectedPlans[];
  setSelectedPlans: (CheckoutState: ICheckoutStateSelectedPlans[]) => void;
}

export const useCheckoutState = create<ICheckoutState>(set => {
  return {
    selectedPlans: sessionStorage.getItem('selectedPlans')
      ? Object.values(JSON.parse(sessionStorage.getItem('selectedPlans')!))
      : [],
    setSelectedPlans(newSelectedPlans: ICheckoutStateSelectedPlans[]) {
      set({ selectedPlans: newSelectedPlans });
      sessionStorage.setItem('selectedPlans', JSON.stringify(newSelectedPlans));
    },
  };
});
